import { CalculatorStore } from '@/store/Calculator'

export const calculatorStore = new CalculatorStore()
